<template>
  <div
      v-show="Object.keys(room).length && showFooter"
      id="room-footer"
      class="vac-room-footer"
      :class="{
			'vac-app-box-shadow': shadowFooter
		}"
  >
    <room-emojis
        :filtered-emojis="filteredEmojis"
        :select-item="selectEmojiItem"
        :active-up-or-down="activeUpOrDownEmojis"
        @select-emoji="selectEmoji($event)"
        @activate-item="activeUpOrDownEmojis = 0"
    />

    <room-users-tag
        :filtered-users-tag="filteredUsersTag"
        :select-item="selectUsersTagItem"
        :active-up-or-down="activeUpOrDownUsersTag"
        @select-user-tag="selectUserTag($event)"
        @activate-item="activeUpOrDownUsersTag = 0"
    />

    <room-templates-text
        :filtered-templates-text="filteredTemplatesText"
        :select-item="selectTemplatesTextItem"
        :active-up-or-down="activeUpOrDownTemplatesText"
        @select-template-text="selectTemplateText($event)"
        @activate-item="activeUpOrDownTemplatesText = 0"
    />

    <room-message-reply
        :room="room"
        :message-reply="messageReply"
        :text-formatting="textFormatting"
        :link-options="linkOptions"
        @reset-message="resetMessage"
    >
      <template v-for="(i, name) in $slots" #[name]="data">
        <slot :name="name" v-bind="data"/>
      </template>
    </room-message-reply>

    <room-files
        :files="files"
        @remove-file="removeFile"
        @reset-message="resetMessage"
    >
      <template v-for="(i, name) in $slots" #[name]="data">
        <slot :name="name" v-bind="data"/>
      </template>
    </room-files>

    <div
        class="vac-box-footer"
        :class="{ 'vac-box-footer-border': !files.length }"
    >
      <textarea
          id="roomTextarea"
          ref="roomTextarea"
          :placeholder="textMessages.TYPE_MESSAGE"
          class="vac-textarea"
          :class="{
					'vac-textarea-outline': editedMessage._id
				}"
          :style="{
					'min-height': `167px`,
					'padding-left': `12px`,
					'height':`167px`,
				}"
          @input="onChangeInput"
          @keydown.esc="escapeTextarea"
          @keydown.enter.exact.prevent="selectItem"
          @paste="onPasteImage"
          @keydown.tab.exact.prevent=""
          @keydown.tab="selectItem"
          @keydown.up="updateActiveUpOrDown($event, -1)"
          @keydown.down="updateActiveUpOrDown($event, 1)"
      />

      <div class="vac-icon-textarea">
        <div
            v-if="editedMessage._id"
            class="vac-svg-button"
            @click="resetMessage"
        >
          <slot name="edit-close-icon">
            <svg-icon name="close-outline"/>
          </slot>
        </div>

        <div v-if="showEmojis" v-click-outside="() => (emojiOpened = false)">
          <slot
              name="emoji-picker"
              v-bind="{ emojiOpened }"
              :add-emoji="addEmoji"
          >
            <emoji-picker-container
                :emoji-opened="emojiOpened"
                :position-top="true"
                :emoji-data-source="emojiDataSource"
                @add-emoji="addEmoji"
                @open-emoji="emojiOpened = $event"
            >
              <template #emoji-picker-icon>
                <!-- <slot name="emoji-picker-icon"/> -->
                <img src="../../../img/text_tool1.png" style="width: 20px;height: 20px;margin-right: 10px;"/>
              </template>
            </emoji-picker-container>
          </slot>
        </div>

         <div class="vac-svg-button" @click="launchImagePicker">
          <!-- 添加图片 -->
          <img src="../../../img/text_tool2.png" style="width: 20px;height: 20px;margin: 0px 10px;"/>
        </div>

        <div v-if="showFiles" class="vac-svg-button" @click="launchFilePicker">
          <slot name="paperclip-icon">
            <!-- <svg-icon name="paperclip"/> -->
            <img src="../../../img/text_tool3.png" style="width: 20px;height: 20px;margin: 0px 10px;"/>
          </slot>
        </div>
       

<!--        <div v-if="showAudio && !files.length" class="vac-icon-textarea-left">-->
<!--        <template v-if="isRecording">-->
<!--          <div class="vac-svg-button vac-icon-audio-stop" @click="stopRecorder">-->
<!--            <slot name="audio-stop-icon">-->
<!--              <svg-icon name="close-outline"/>-->
<!--            </slot>-->
<!--          </div>-->

<!--          <div class="vac-dot-audio-record"/>-->

<!--          <div class="vac-dot-audio-record-time">-->
<!--            {{ recordedTime }}-->
<!--          </div>-->

<!--          <div-->
<!--              class="vac-svg-button vac-icon-audio-confirm"-->
<!--              @click="toggleRecorder(false)"-->
<!--          >-->
<!--            <slot name="audio-check-icon">-->
<!--              <svg-icon name="checkmark"/>-->
<!--            </slot>-->
<!--          </div>-->
<!--        </template>-->

<!--        <div v-else class="vac-svg-button" @click="toggleRecorder(true)">-->
<!--          <slot name="microphone-icon">-->
<!--            <svg-icon name="microphone" class="vac-icon-microphone"/>-->
<!--          </slot>-->
<!--        </div>-->
<!--      </div>-->

        <div
            v-if="textareaActionEnabled"
            class="vac-svg-button"
            @click="textareaActionHandler"
        >
          <slot name="custom-action-icon">
            <svg-icon name="deleted"/>
          </slot>
        </div>

        <input
            v-if="showFiles"
            ref="file"
            type="file"
            :multiple="multipleFiles ? true : null"
            :accept="acceptedFiles"
            :capture="captureFiles"
            style="display: none"
            @change="onFileChange($event.target.files)"
        />

        <input
            ref="imageFile"
            type="file"
            accept="image/*"
            style="display: none"
            @change="onImageChange($event.target.files)"
        />

        <div
            v-if="showSendIcon"
            class="vac-svg-button vac-svg-button-sp-april"
            :class="{ 'vac-send-disabled': isMessageEmpty }"
            @click="sendMessage"
        >
          <slot name="send-icon">
            <!--            <svg-icon-->
            <!--                name="send"-->
            <!--                :param="isMessageEmpty || isFileLoading ? 'disabled' : ''"-->
            <!--            />-->
            <el-button  type="primary" :disabled="isMessageEmpty || isFileLoading">
              <template #icon>
                <svg
                style="position: absolute;
                           right: -5px;
                           top: 0px;
                          }"
                    name="send"
                    :param="isMessageEmpty || isFileLoading ? 'disabled' : ''"
                t="1773977228932" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2526" width="20" height="20"><path d="M955 125.6c-4.5-12.5-15.4-21.8-28.6-24.2-9.2-1.7-18.4 0.1-26.1 4.8L83.9 544.3c-12.8 6.8-20.6 20.6-19.8 35.1 0.8 14.3 9.9 27.3 23.2 32.9l238.5 97.9c12.4 5.2 26.8 3.4 37.5-4.9s16.1-21.3 14.4-34.8c-1.6-13.2-10.4-24.6-23-29.9l-165-67.7 573-307.3-357 421.9c-6.5 7.7-9.6 17.4-8.8 27.4L411.4 884c1.6 19.7 17.7 34.6 37.5 34.6 9.5 0 18.7-3.7 25.8-10.4l74-69.2 0.1-0.1c13.5-13.2 15.2-33.5 4.8-48.4l222.6 72c4 1.3 7.9 2 11.7 2 18.2 0 33.8-12.9 37-30.6l131.6-688.3h-0.1c1.4-6.6 0.9-13.5-1.4-20zM497.3 783.8L479.9 800l-6.5-75.9L856 271.6l-96.8 506.3L539 706.6c-19.7-6.4-41.1 4.4-47.5 24.2-5.8 17.9 2.5 37.1 18.9 45.4-4.7 1.5-9.2 4-13.1 7.6z" p-id="2527" fill="#ffffff"></path></svg>
              </template>
              <template #default>
                发送
              </template>
            </el-button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Database} from 'emoji-picker-element'

import SvgIcon from '@/modules/whatsapp/components/SvgIcon/SvgIcon.vue'
import EmojiPickerContainer from '@/modules/whatsapp/components/EmojiPickerContainer/EmojiPickerContainer.vue'

import RoomFiles from './RoomFiles/RoomFiles.vue'
import RoomMessageReply from './RoomMessageReply/RoomMessageReply.vue'
import RoomUsersTag from './RoomUsersTag/RoomUsersTag.vue'
import RoomEmojis from './RoomEmojis/RoomEmojis.vue'
import RoomTemplatesText from './RoomTemplatesText/RoomTemplatesText.vue'

import vClickOutside from '@/modules/whatsapp/utils/on-click-outside'
import filteredItems from '@/modules/whatsapp/utils/filter-items'
import Recorder from '@/modules/whatsapp/utils/recorder'

import {detectChrome} from '@/modules/whatsapp/utils/browser-detection'
import {detectMobile} from '@/modules/whatsapp/utils/mobile-detection'
import { uploadFile as uploadFileToOss } from '@/utils/file'

export default {
  name: 'RoomFooter',

  components: {
    SvgIcon,
    EmojiPickerContainer,
    RoomFiles,
    RoomMessageReply,
    RoomUsersTag,
    RoomEmojis,
    RoomTemplatesText
  },

  directives: {
    clickOutside: vClickOutside
  },

  props: {
    room: {type: Object, required: true},
    roomId: {type: [String, Number], required: true},
    roomMessage: {type: String, default: null},
    textFormatting: {type: Object, required: true},
    linkOptions: {type: Object, required: true},
    textMessages: {type: Object, required: true},
    showSendIcon: {type: Boolean, required: true},
    showFiles: {type: Boolean, required: true},
    showAudio: {type: Boolean, required: true},
    showEmojis: {type: Boolean, required: true},
    showFooter: {type: Boolean, required: true},
    acceptedFiles: {type: String, required: true},
    multipleFiles: {type: Boolean, default: true},
    captureFiles: {type: String, required: true},
    textareaActionEnabled: {type: Boolean, required: true},
    textareaAutoFocus: {type: Boolean, required: true},
    userTagsEnabled: {type: Boolean, required: true},
    emojisSuggestionEnabled: {type: Boolean, required: true},
    templatesText: {type: Array, default: null},
    audioBitRate: {type: Number, required: true},
    audioSampleRate: {type: Number, required: true},
    initReplyMessage: {type: Object, default: null},
    initEditMessage: {type: Object, default: null},
    droppedFiles: {type: Array, default: null},
    emojiDataSource: {type: String, default: undefined}
  },

  emits: [
    'edit-message',
    'send-message',
    'update-edited-message-id',
    'textarea-action-handler',
    'typing-message'
  ],

  data() {
    return {
      message: '',
      editedMessage: {},
      messageReply: null,
      cursorRangePosition: null,
      files: [],
      fileLoading: false,
      fileDialog: false,
      selectUsersTagItem: null,
      selectEmojiItem: null,
      selectTemplatesTextItem: null,
      format: 'mp3',
      activeUpOrDownEmojis: null,
      activeUpOrDownUsersTag: null,
      activeUpOrDownTemplatesText: null,
      emojisDB: new Database({dataSource: this.emojiDataSource}),
      emojiOpened: false,
      keepKeyboardOpen: false,
      filteredEmojis: [],
      filteredUsersTag: [],
      selectedUsersTag: [],
      filteredTemplatesText: [],
      recorder: this.initRecorder(),
      isRecording: false
    }
  },

  computed: {
    isMessageEmpty() {
      return !this.files.length && !this.message.trim()
    },
    isFileLoading() {
      return this.fileLoading
    },
    recordedTime() {
      return new Date(this.recorder.duration * 1000).toISOString().substr(14, 5)
    },
    shadowFooter() {
      return (
          !!this.filteredEmojis.length ||
          !!this.filteredUsersTag.length ||
          !!this.filteredTemplatesText.length ||
          !!this.files.length ||
          !!this.messageReply
      )
    }
  },

  watch: {
    roomId() {
      this.resetMessage(true, true)

      if (this.roomMessage) {
        this.message = this.roomMessage
        setTimeout(() => this.onChangeInput())
      }
    },
    message(val) {
      this.getTextareaRef().value = val
    },
    roomMessage: {
      immediate: true,
      handler(val) {
        if (val) this.message = this.roomMessage
      }
    },
    editedMessage(val) {
      this.$emit('update-edited-message-id', val._id)
    },
    initReplyMessage(val) {
      if (val) {
        this.replyMessage(val)
      }
    },
    initEditMessage(val) {
      if (val) {
        this.editMessage(val)
      }
    },
    droppedFiles(val) {
      if (val) {
        this.onFileChange(val)
      }
    }
  },

  mounted() {
    const isMobile = detectMobile()
    let isComposed = true

    this.getTextareaRef().addEventListener('keyup', e => {
      if (e.key === 'Enter' && !e.shiftKey && !this.fileDialog) {
        if (isMobile) {
          this.message = this.message + '\n'
          setTimeout(() => this.onChangeInput())
        } else if (
            isComposed &&
            !this.filteredEmojis.length &&
            !this.filteredUsersTag.length &&
            !this.filteredTemplatesText.length
        ) {
          this.sendMessage()
        }
      }
      isComposed = !e.isComposing

      setTimeout(() => {
        this.updateFooterLists()
      }, 60)
    })

    this.getTextareaRef().addEventListener('click', () => {
      if (isMobile) this.keepKeyboardOpen = true
      this.updateFooterLists()
    })

    this.getTextareaRef().addEventListener('blur', () => {
      setTimeout(() => {
        this.resetFooterList()
      }, 100)

      if (isMobile) setTimeout(() => (this.keepKeyboardOpen = false))
    })
  },

  beforeUnmount() {
    this.stopRecorder()
  },

  methods: {
    getTextareaRef() {
      return this.$refs.roomTextarea
    },
    focusTextarea(disableMobileFocus) {
      if (detectMobile() && disableMobileFocus) return
      if (!this.getTextareaRef()) return
      this.getTextareaRef().focus()

      if (this.cursorRangePosition) {
        setTimeout(() => {
          const offset = detectChrome() ? 0 : 1
          this.getTextareaRef().setSelectionRange(
              this.cursorRangePosition + offset,
              this.cursorRangePosition + offset
          )
          this.cursorRangePosition = null
        })
      }
    },
    onChangeInput() {
      if (this.getTextareaRef()?.value || this.getTextareaRef()?.value === '') {
        this.message = this.getTextareaRef()?.value
      }
      this.keepKeyboardOpen = true
      this.resizeTextarea()
      this.$emit('typing-message', this.message)
    },
    resizeTextarea() {
      const el = this.getTextareaRef()

      if (!el) return

      const padding = window
          .getComputedStyle(el, null)
          .getPropertyValue('padding-top')
          .replace('px', '')

      el.style.height = 0
      el.style.height = el.scrollHeight - padding * 2 + 'px'
    },
    escapeTextarea() {
      if (this.filteredEmojis.length) this.filteredEmojis = []
      else if (this.filteredUsersTag.length) this.filteredUsersTag = []
      else if (this.filteredTemplatesText.length) {
        this.filteredTemplatesText = []
      } else this.resetMessage()
    },
    onPasteImage(pasteEvent) {
      const items = pasteEvent.clipboardData?.items

      if (items) {
        Array.from(items).forEach(item => {
          if (item.type.includes('image')) {
            const blob = item.getAsFile()
            this.onFileChange([blob])
          }
        })
      }
    },
    updateActiveUpOrDown(event, direction) {
      if (this.filteredEmojis.length) {
        this.activeUpOrDownEmojis = direction
        event.preventDefault()
      } else if (this.filteredUsersTag.length) {
        this.activeUpOrDownUsersTag = direction
        event.preventDefault()
      } else if (this.filteredTemplatesText.length) {
        this.activeUpOrDownTemplatesText = direction
        event.preventDefault()
      }
    },
    selectItem() {
      if (this.filteredEmojis.length) {
        this.selectEmojiItem = true
      } else if (this.filteredUsersTag.length) {
        this.selectUsersTagItem = true
      } else if (this.filteredTemplatesText.length) {
        this.selectTemplatesTextItem = true
      }
    },
    selectEmoji(emoji) {
      this.selectEmojiItem = false

      if (!emoji) return

      const {position, endPosition} = this.getCharPosition(':')

      this.message =
          this.message.substr(0, position - 1) +
          emoji +
          this.message.substr(endPosition, this.message.length - 1)

      this.cursorRangePosition = position
      this.focusTextarea()
    },
    selectTemplateText(template) {
      this.selectTemplatesTextItem = false

      if (!template) return

      const {position, endPosition} = this.getCharPosition('/')

      const space = this.message.substr(endPosition, endPosition).length
          ? ''
          : ' '

      this.message =
          this.message.substr(0, position - 1) +
          template.text +
          space +
          this.message.substr(endPosition, this.message.length - 1)

      this.cursorRangePosition =
          position + template.text.length + space.length + 1

      this.focusTextarea()
    },
    addEmoji(emoji) {
      this.message += emoji.unicode
      this.focusTextarea(true)
    },
    launchFilePicker() {
      this.$refs.file.value = ''
      this.$refs.file.click()
    },
    launchImagePicker() {
      this.$refs.imageFile.value = ''
      this.$refs.imageFile.click()
    },
    onImageChange(files) {
      const list = Array.from(files || [])
      if (!list.length) return
      const invalid = list.find((f) => !(f && typeof f.type === 'string' && f.type.startsWith('image/')))
      if (invalid) {
        this.$message?.warning?.('这里只能选择图片文件')
        return
      }
      return this.onFileChange(list)
    },
    async onFileChange(files) {
      this.fileDialog = true
      this.focusTextarea()

      Array.from(files).forEach(async file => {
        const fileURL = URL.createObjectURL(file)
        const typeIndex = file.name.lastIndexOf('.')

        const fileObj = {
          loading: true,
          uploadProgress: 0,
          name: file.name.substring(0, typeIndex),
          size: file.size,
          type: file.type,
          extension: file.name.substring(typeIndex + 1),
          localUrl: fileURL,
          url: null // 上传后的 URL
        }
        this.files.push(fileObj)
        this.fileLoading = true

        // 立即开始上传
        try {
          const res = await uploadFileToOss(file, (percent) => {
            fileObj.uploadProgress = percent
          })
          fileObj.url = res?.url || res?.result?.url || ''
          fileObj.loading = false
          this.fileLoading = this.files.some(f => f.loading)
        } catch (e) {
          fileObj.loading = false
          fileObj.uploadError = true
          this.fileLoading = this.files.some(f => f.loading)
          this.$message?.error?.('文件上传失败: ' + (e?.message || '未知错误'))
        }
      })

      setTimeout(() => (this.fileDialog = false), 500)
    },
    removeFile(index) {
      this.files.splice(index, 1)
      this.fileLoading = this.files.some(f => f.loading)
      this.focusTextarea()
    },
    toggleRecorder(recording) {
      this.isRecording = recording

      if (!this.recorder.isRecording) {
        setTimeout(() => this.recorder.start(), 200)
      } else {
        try {
          this.recorder.stop()

          const record = this.recorder.records[0]

          this.files.push({
            blob: record.blob,
            name: `audio.${this.format}`,
            size: record.blob.size,
            duration: record.duration,
            type: record.blob.type,
            audio: true,
            localUrl: URL.createObjectURL(record.blob)
          })

          this.recorder = this.initRecorder()
          this.sendMessage()
        } catch {
          setTimeout(() => this.stopRecorder(), 100)
        }
      }
    },
    stopRecorder() {
      if (this.recorder.isRecording) {
        try {
          this.recorder.stop()
          this.recorder = this.initRecorder()
        } catch {
          setTimeout(() => this.stopRecorder(), 100)
        }
      }
    },
    textareaActionHandler() {
      this.$emit('textarea-action-handler', this.message)
    },
    sendMessage() {
      let message = this.message.trim()

      if (!this.files.length && !message) return

      if (this.isFileLoading) return

      this.selectedUsersTag.forEach(user => {
        message = message.replace(
            `@${user.username}`,
            `<usertag>${user._id}</usertag>`
        )
      })

      const files = this.files.length ? this.files : null

      if (this.editedMessage._id) {
        if (
            this.editedMessage.content !== message ||
            this.editedMessage.files?.length ||
            this.files.length
        ) {
          this.$emit('edit-message', {
            messageId: this.editedMessage._id,
            newContent: message,
            files: files,
            replyMessage: this.messageReply,
            usersTag: this.selectedUsersTag
          })
        }
      } else {
        this.$emit('send-message', {
          content: message,
          files: files,
          replyMessage: this.messageReply,
          usersTag: this.selectedUsersTag
        })
      }

      this.resetMessage(true)
    },
    editMessage(message) {
      this.resetMessage()

      this.editedMessage = {...message}

      let messageContent = message.content
      const initialContent = messageContent

      const firstTag = '<usertag>'
      const secondTag = '</usertag>'

      const usertags = [
        ...messageContent.matchAll(new RegExp(firstTag, 'gi'))
      ].map(a => a.index)

      usertags.forEach(index => {
        const userId = initialContent.substring(
            index + firstTag.length,
            initialContent.indexOf(secondTag, index)
        )

        const user = this.room.users.find(user => user._id === userId)

        messageContent = messageContent.replace(
            `${firstTag}${userId}${secondTag}`,
            `@${user?.username || 'unknown'}`
        )

        this.selectUserTag(user, true)
      })

      this.message = messageContent

      if (message.files) {
        this.files = [...message.files]
      }

      setTimeout(() => this.resizeTextarea())
    },
    replyMessage(message) {
      this.editedMessage = {}
      this.messageReply = message
      this.focusTextarea()
    },
    updateFooterLists() {
      this.updateFooterList('@')
      this.updateFooterList(':')
      this.updateFooterList('/')
    },
    updateFooterList(tagChar) {
      if (!this.getTextareaRef()) return

      if (tagChar === ':' && !this.emojisSuggestionEnabled) {
        return
      }

      if (tagChar === '@' && (!this.userTagsEnabled || !this.room.users)) {
        return
      }

      if (tagChar === '/' && !this.templatesText) {
        return
      }

      const textareaCursorPosition = this.getTextareaRef().selectionStart

      let position = textareaCursorPosition

      while (
          position > 0 &&
          this.message.charAt(position - 1) !== tagChar &&
          // eslint-disable-next-line no-unmodified-loop-condition
          (this.message.charAt(position - 1) !== ' ' || tagChar !== ':')
          ) {
        position--
      }

      const beforeTag = this.message.charAt(position - 2)
      const notLetterNumber = !beforeTag.match(/^[0-9a-zA-Z]+$/)

      if (
          this.message.charAt(position - 1) === tagChar &&
          (!beforeTag || beforeTag === ' ' || notLetterNumber)
      ) {
        const query = this.message.substring(position, textareaCursorPosition)
        if (tagChar === ':') {
          this.updateEmojis(query)
        } else if (tagChar === '@') {
          this.updateShowUsersTag(query)
        } else if (tagChar === '/') {
          this.updateShowTemplatesText(query)
        }
      } else {
        this.resetFooterList(tagChar)
      }
    },
    updateShowUsersTag(query) {
      this.filteredUsersTag = filteredItems(
          this.room.users,
          'username',
          query,
          true
      ).filter(user => user._id !== this.currentUserId)
    },
    selectUserTag(user, editMode = false) {
      this.selectUsersTagItem = false

      if (!user) return

      const {position, endPosition} = this.getCharPosition('@')

      const space = this.message.substr(endPosition, endPosition).length
          ? ''
          : ' '

      this.message =
          this.message.substr(0, position) +
          user.username +
          space +
          this.message.substr(endPosition, this.message.length - 1)

      this.selectedUsersTag = [...this.selectedUsersTag, {...user}]

      if (!editMode) {
        this.cursorRangePosition =
            position + user.username.length + space.length + 1
      }

      this.focusTextarea()
    },
    updateShowTemplatesText(query) {
      this.filteredTemplatesText = filteredItems(
          this.templatesText,
          'tag',
          query,
          true
      )
    },
    getCharPosition(tagChar) {
      const cursorPosition = this.getTextareaRef().selectionStart

      let position = cursorPosition
      while (position > 0 && this.message.charAt(position - 1) !== tagChar) {
        position--
      }

      const endPosition = this.getTextareaRef().selectionEnd

      return {position, endPosition}
    },
    async updateEmojis(query) {
      if (!query) return

      const emojis = await this.emojisDB.getEmojiBySearchQuery(query)
      this.filteredEmojis = emojis.map(emoji => emoji.unicode)
    },
    resetFooterList(tagChar = null) {
      if (tagChar === ':') {
        this.filteredEmojis = []
      } else if (tagChar === '@') {
        this.filteredUsersTag = []
      } else if (tagChar === '/') {
        this.filteredTemplatesText = []
      } else {
        this.filteredEmojis = []
        this.filteredUsersTag = []
        this.filteredTemplatesText = []
      }
    },
    resetMessage(disableMobileFocus = false, initRoom = false) {
      if (!initRoom) {
        this.$emit('typing-message', null)
      }

      this.selectedUsersTag = []
      this.resetFooterList()
      this.resetTextareaSize()
      this.message = ''
      this.editedMessage = {}
      this.messageReply = null
      this.files = []
      this.fileLoading = false
      this.emojiOpened = false
      this.preventKeyboardFromClosing()

      if (this.textareaAutoFocus || !initRoom) {
        setTimeout(() => this.focusTextarea(disableMobileFocus))
      }
    },
    resetTextareaSize() {
      if (this.getTextareaRef()) {
        this.getTextareaRef().style.height = '167px'
      }
    },
    preventKeyboardFromClosing() {
      if (this.keepKeyboardOpen) this.getTextareaRef().focus()
    },
    initRecorder() {
      this.isRecording = false

      return new Recorder({
        bitRate: Number(this.audioBitRate),
        sampleRate: Number(this.audioSampleRate),
        beforeRecording: null,
        afterRecording: null,
        pauseRecording: null,
        micFailed: this.micFailed
      })
    },
    micFailed() {
      this.isRecording = false
      this.recorder = this.initRecorder()
    }
  }
}
</script>
